import React, { useEffect, useState } from 'react';
import Modal from 'react-awesome-modal';
import { useSelector } from 'react-redux';

export default function DialogSfPlusVlidatePin({
    open,
    error,
    submitDialog,
    closeDialog,
    deliveryAddressAndShippingCost
}) {
    const [pin, setPin] = useState('');
    const [btnSubmitState, setBtnSubmitState] = useState(false);
    const wording = useSelector(({ language }) => language.wording);

    useEffect(() => {
        if (pin && pin.length > 3) {
            setBtnSubmitState(true);
        }
        if (pin && pin.length < 3) {
            setBtnSubmitState(false);
        }
    }, [pin]);

    function handlePinChange(event) {
        const newpin = event.target.value;
        setPin(newpin);
    }

    function numberRemove() {
        let newPin = pin;
        newPin = newPin.slice(0, -1);
        setPin(newPin);
    }

    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            if (pin && pin.length > 3) {
                handleSubmit();
            }
        }
        if (e.key === 'Backspace') {
            numberRemove();
        }
    }

    function clearPin() {
        setPin('');
    }

    function handleSubmit() {
        submitDialog(pin, deliveryAddressAndShippingCost);
    }

    return (
        <Modal
            visible={open}
            width='450'
            effect='fadeInUp'
            onClickAway={() => {
                clearPin();
                closeDialog();
            }}>
            <div style={{ margin: 20 }}>
                <div className='dialog-header'>
                    <h4 style={{ color: '#2d64cf' }}>
                        {wording.checkoutPage.dialogPin.title}
                    </h4>
                </div>
                <div className='dialog-body mt-20 mb-20'>
                    <input
                        style={{ color: '#7a7a7a' }}
                        name='pin'
                        id='pin'
                        type='password'
                        placeholder={wording.checkoutPage.dialogPin.inputPin}
                        maxLength='4'
                        value={pin}
                        onChange={handlePinChange}
                        onKeyDown={handleKeyDown}
                    />
                    {error && (
                        <div
                            className='alert alert-danger fade in alert-dismissible'
                            role='alert'>
                            {error}
                        </div>
                    )}
                </div>
                <div className='dialog-action row'>
                    <div className='col-md-6'>
                        <button
                            style={{ width: '100%' }}
                            className='btn btn-md btn-dark'
                            disabled={!btnSubmitState}
                            onClick={handleSubmit}>
                            {wording.checkoutPage.dialogPin.ok}
                        </button>
                    </div>
                    <div className='col-md-6'>
                        <button
                            style={{ width: '100%' }}
                            className='btn btn-md btn-light-red'
                            onClick={() => {
                                clearPin();
                                closeDialog();
                            }}>
                            {wording.checkoutPage.dialogPin.cancle}
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
